import { Types, Actions } from './actions';
import authApi from '~/api';
import { get } from '~/utils/object';

const middleware = (store: any) => (next: any) => (action: any) => {
  const { dispatch } = store;
  if (action.type === Types.FORGOT_PASSWORD_REQUEST) {
    const username = get(action, 'payload.username');
    authApi
      .post('/auth/forgot-password', { username }) // todo: this path does not belong here
      .then(res => {
        // todo: not sure how to type this
        // @ts-ignore
        dispatch(Actions.FORGOT_PASSWORD_SUCCESS(res.data));
      })
      .catch(err => {
        dispatch(Actions.FORGOT_PASSWORD_ERROR(err));
      });
  }
  if (action.type === Types.PASSWORD_RULES_REQUEST) {
    const { resetToken } = action.payload;
    authApi
      .post('/auth/password-rules', { resetToken }) // todo: this path does not belong here
      .then((res: any) => {
        const { ok, status, data } = res;
        if (status === 400) {
          // user did not provide a resetToken
          const error = get(
            data,
            'error.message',
            'Failed to fetch password rules',
          );
          dispatch(Actions.PASSWORD_RULES_FAILURE(error));
        }
        if (ok) {
          dispatch(Actions.PASSWORD_RULES_SUCCESS(data));
        }
      })
      .catch(err => {
        dispatch(Actions.PASSWORD_RULES_ERROR(err));
      });
  }
  if (action.type === Types.RESET_PASSWORD_REQUEST) {
    const { resetToken, password } = action.payload;
    authApi
      .post('/auth/reset-password', { password, resetToken }) // todo: this path does not belong here
      .then((res: any) => {
        const { ok, problem, data } = res;
        if (ok) {
          dispatch(Actions.RESET_PASSWORD_SUCCESS(data));
        } else {
          dispatch(Actions.RESET_PASSWORD_FAILURE(problem));
        }
      })
      .catch(err => {
        dispatch(Actions.RESET_PASSWORD_ERROR(err));
      });
  }

  next(action);
};

export default middleware;
